import { useLocation } from 'react-router';
import { useAppSelector } from '.';
import { postEvent } from '../core/api';
import { useVisitor } from '../context/useVisitor';
import { sendHotjarEvent } from '@/core/helpers';
import { activeCompanySelector } from '@/core/store/user/userSlice';

export enum APIEventsEnum {
  files_uploaded_from_document_tab = 'files_uploaded_from_document_tab',
  download_errors_file_form_documents_tab = 'download_errors_file_form_documents_tab',
  view_document_tab = 'view_document_tab',
  view_new_turnover_section = 'view_new_turnover_section',
  files_uploaded_from_new_turnover_section = 'files_uploaded_from_new_turnover_section',
  click_datev_schedule_interview = 'click_datev_schedule_interview',
  download_datev_file = 'download_datev_file',
  calendly_booked_website = 'calendly_booked_website',
  cookie_policy_accepted = 'cookie_policy_accepted',
  cookie_policy_declined = 'cookie_policy_declined',
  cookie_banner_view = 'cookie_banner_view',
  click_cta = 'click_cta',
  view_cta = 'view_cta',
  click_datev_fake_door = 'click_datev_fake_door',
  click_upload_purchase_prices = 'click_upload_purchase_prices',
  purchase_prices_uploaded_correctly = 'purchase_prices_uploaded_correctly',
  purchase_prices_uploaded_unorrectly = 'purchase_prices_uploaded_unorrectly',
  view_payment_instruction = 'view_payment_instruction',
  payment_instruction_marked_paid = 'payment_instruction_marked_paid',
  view_report_confirmation = 'view_report_confirmation',
  download_report_confirmation = 'download_report_confirmation',
  download_proforma_invoice = 'download_proforma_invoice',
  report_submition_agenda = 'report_submition_agenda',
  click_sidebar_link = 'click_sidebar_link',
  download_manual_upload_instruction = 'download_manual_upload_instruction',
  download_manual_upload_template = 'download_manual_upload_template',
  download_incoming_invoices_template = 'download_incoming_invoices_template',
  click_download_invoice_book = 'click_download_invoice_book',
  manual_upload_file_success = 'manual_upload_file_success',
  manual_upload_file_fail = 'manual_upload_file_fail',
  click_connect_amazon = 'click_connect_amazon',
  click_connect_easybill = 'click_connect_easybill',
  click_connect_billbee = 'click_connect_billbee',
  payment_overdue_client_login = 'payment_overdue_client_login',
  oss_sese_marked_as_submitted = 'oss_sese_marked_as_submitted',
  confirm_data_unit = 'confirm_data_unit',
  mute_invoice = 'mute_invoice',
  invoice_not_clear = 'invoice_not_clear',
  error_not_clear = 'error_not_clear',
  files_uploaded_from_turnover_todo = 'files_uploaded_from_turnover_todo',
  update_chart_of_accounts = 'update_chart_of_accounts',
  click_chart_of_accounts_link = 'click_chart_of_accounts_link',
  click_generate_datev = 'click_generate_datev',
  click_confirm_regenerate_datev = 'click_confirm_regenerate_datev',
  click_regenerate_datev_shipment = 'click_regenerate_datev_shipment',
  click_generate_jtl_credentials = 'click_generate_jtl_credentials',
  register_tax_advisor_with_invitation = 'register_tax_advisor_with_invitation',
  invitation_created = 'invitation_created',
  invitation_accepted = 'invitation_accepted',
  change_datev_settings = 'change_datev_settings',
  open_ic_sales_transactions_overview = 'open_ic_sales_transactions_overview',
  open_proforma_overview = 'open_proforma_overview',
  download_proforma = 'download_proforma',
  download_proformas_for_country = 'download_proformas_for_country',
  download_proformas_for_month = 'download_proformas_for_month',
  click_datev_transactions_overview_link = 'click_datev_transactions_overview_link',
  pp_faq_opened = 'pp_faq_opened',
  click_onboarding_sidebar = 'click_onboarding_sidebar',
  click_billing_stripe_link = 'click_billing_stripe_link',
  click_pp_fake_door = 'click_pp_fake_door',
  purchase_prices_last_month_uploaded = 'purchase_prices_last_month_uploaded',
  oss_payment_instruction_marked_paid = 'oss_payment_instruction_marked_paid',
  download_all_missing_pp = 'download_all_missing_pp',
  download_last_month_missing_pp = 'download_last_month_missing_pp',
  download_available_pp = 'download_available_pp',
  click_estimated_amount_modal = 'click_estimated_amount_modal',
  click_confirmed_amount_modal = 'click_confirmed_amount_modal',
  download_extf_datev_file = 'download_extf_datev_file',
  download_enriched_datev_file = 'download_enriched_datev_file',
  download_raw_settlement_file = 'download_raw_settlement_file',
  download_raw_settlement_files_as_zip = 'download_raw_settlement_files_as_zip',
  click_connex_onboarding_chart_of_account_accepted = 'click_connex_onboarding_chart_of_account_accepted',
  click_connex_onboarding_activate_expenses = 'click_connex_onboarding_activate_expenses',
  click_connex_show_visualization = 'click_connex_show_visualization',
  click_connex_onboarding_banner = 'click_connex_onboarding_banner',
  click_T4DTDeinstallation_confirmed = 'click_T4DTDeinstallation_confirmed',
  click_JeraConnectorManualUpload_confirmed = 'click_JeraConnectorManualUpload_confirmed',
  click_connex_regenerate_export = 'click_connex_regenerate_export',
}

export interface Event {
  application: string;
  type: APIEventsEnum;
  source?: string;
  block?: string;
  query_string?: string;
  metadata?: string;
  url?: string;
  company_uuid?: string;
}

export const useSendEvent = () => {
  const { visitorId } = useVisitor();
  const userId = useAppSelector((s) => s.user.user?.AmazonCognitoId);
  const location = useLocation();
  const activeCompany = useAppSelector(activeCompanySelector);

  return {
    sendEvent: (type: APIEventsEnum, metadata: { [key: string]: string }) => {
      sendHotjarEvent(type);
      postEvent(userId || visitorId, {
        application: 'customer-app',
        type,
        query_string: location.search,
        url: location.pathname,
        company_uuid: activeCompany?.company_id,
        metadata: JSON.stringify(metadata),
      }).catch(console.error);
    },
  };
};
